import { Outlet } from 'react-router';

const AuthLayout = () => {
  return (
    <div className="w-screen min-h-screen flex justify-center items-center border">
      <Outlet />
    </div>
  );
};

export default AuthLayout;
